export const price = {
  participantDestroyed(store, participant) {
    const destroyPrice = store.getters.currentAge.priceDestroyed;
    if (destroyPrice == 0)
      return 0;

    if (destroyPrice < 1)
      return destroyPrice * this.participant(store.state, participant);

    return destroyPrice;
  },
  participant(state, participant) {
    const participantAge = state.ages[participant.createdInAgeId];

    // base price
    let price = participantAge.priceCreated;

    // days price
    let activePD = participant.partilyDays;
    let count = 0;
    while (activePD != 0) {
      activePD = activePD & (activePD - 1);
      count++;
    }
    price += count * participantAge.dayPriceCreated;

    if (participant.isServant && participant.isServantConfirmed)
      price -= state.config.servantDiscount;

    if (state.outpost.additionalParticipantPrice != null)
      price += state.outpost.additionalParticipantPrice;

    return price;
  }
};
